// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__32qXT","inputWrap":"styles_inputWrap__fbNFU","input":"styles_input__PRUBu"};